import { useQuery } from '@tanstack/react-query';
import { queryClient } from 'contexts/QueryClient';
import { useAuth } from 'pages/AuthProvider';

const queryKey = 'company';

export default function useCompany(id?: string) {
  const {
    clients: { company },
  } = useAuth();
  return useQuery({
    queryKey: [queryKey, id],
    queryFn: () => {
      if (id) {
        return company.getCompany({ id });
      }
      return null;
    },
  });
}

export const invalidateCompany = (id: string) => {
  return queryClient.invalidateQueries({ queryKey: [queryKey, id] });
};
